import { render, staticRenderFns } from "./Proposition65WarningSymbol.vue?vue&type=template&id=03970b36&scoped=true"
import script from "./Proposition65WarningSymbol.vue?vue&type=script&lang=js"
export * from "./Proposition65WarningSymbol.vue?vue&type=script&lang=js"
import style0 from "./Proposition65WarningSymbol.vue?vue&type=style&index=0&id=03970b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03970b36",
  null
  
)

export default component.exports